import { FC } from 'react';
import { EstimateCrownIcon, SubscriptionPopper } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { VoidFn } from 'types/baseTypes';

interface EstimateSubscribedModalProps {
  onClose: VoidFn;
  handleCreateNewEstimate: VoidFn;
}

const EstimateSubscribedModal: FC<EstimateSubscribedModalProps> = ({ onClose, handleCreateNewEstimate }) => {
  return (
    <CustomModal open={true} width="md:w-[489px]">
      <>
        <SubscriptionPopper />
        <div className="mx-auto -mt-9 mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondaryBtn">
          <EstimateCrownIcon />
        </div>
        <div className="mb-3 text-center text-2xl font-bold text-heading">You've subscribed to estimates!</div>
        <div className="mb-6 text-center text-17px text-accentText">Let's create your first estimate</div>
        <div className="m-4">
          <CustomButton
            id="create-new-estimate-button"
            type={ButtonType.PRIMARY}
            onClick={handleCreateNewEstimate}
            className="h-12 w-full">
            Create new estimate
          </CustomButton>
        </div>
        <div className="m-4 mb-6">
          <CustomButton
            className="h-12 w-full"
            type={ButtonType.SECONDARY}
            id="create-new-estimate-cancel"
            onClick={onClose}>
            Cancel
          </CustomButton>
        </div>
      </>
    </CustomModal>
  );
};

export default EstimateSubscribedModal;
